export const businessInfo = {
  name: "Pereira Plomberie Chauffage",
  shortName: "Pereira Plomberie",
  slogan: "Votre artisan de confiance à Meaux et alentours",
  phone: "06 73 87 88 61",
  phoneTel: "tel:0673878861",
  phoneFax: "01 60 23 02 36",
  email: "entpereira@icloud.com",
  emailLink: "mailto:entpereira@icloud.com",
  address: {
    street: "32 Chemin de Flandres",
    city: "Meaux",
    zip: "77100",
    full: "32 Chemin de Flandres, 77100 Meaux",
  },
  publisher: "Paulo PEREIRA",
  hosting: {
    name: "Météris Informatique",
    address: "8 rue Georges Claude, 77100 MEAUX",
    website: "https://meteris.fr",
    label: "meteris.fr",
  },
  googleReviewUrl: "https://www.google.com/search?si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qORKi-FalI1Uj_tDamZQUld1m2hVjqYsPWL5O7zCDP8kErHf4XgC98OloJwBqch5uBDi4KllWkccnyZUfrL4oq3ximGo7N4q3oVESsEyKgzR0GDsG2tvilACjTmZpVhTvWGTwTSI%3D&q=Pereira+Plombier+Chauffagiste+Meaux+Avis",
  googleReviewCount: 142,
  googleReviewRating: 4.8,
  emergency: true,
  emergencyText: "Urgence 7j/7",
  logo: "[LOGO_FINAL]",
  domain: "pereiraplomberiechauffage.fr",
};

export const services = [
  {
    slug: "depannage-plomberie",
    title: "Dépannage plomberie",
    shortDesc: "Intervention rapide pour fuites, canalisations bouchées, robinetterie défaillante.",
    description: "Une fuite d'eau, un WC bouché, un robinet qui goutte ? Notre équipe intervient rapidement à Meaux et dans les communes voisines pour résoudre tous vos problèmes de plomberie. Nous diagnostiquons la panne et effectuons la réparation dans les meilleurs délais, avec un travail soigné et durable.",
    benefit: "Intervention rapide, diagnostic précis, réparation durable.",
    icon: "Wrench",
    seoTitle: "Dépannage Plomberie à Meaux (77) | Pereira Plomberie Chauffage",
    seoDescription: "Dépannage plomberie rapide à Meaux et alentours. Fuites, canalisations bouchées, robinetterie. Artisan local réactif. Devis gratuit. Appelez le 06 73 87 88 61.",
  },
  {
    slug: "installation-sanitaire",
    title: "Installation sanitaire",
    shortDesc: "Pose de WC, lavabos, douches, baignoires et équipements sanitaires.",
    description: "Vous construisez, rénovez ou souhaitez simplement remplacer un équipement ? Nous installons tous types de sanitaires : WC suspendus ou classiques, lavabos, douches à l'italienne, baignoires, colonnes de douche. Nous vous conseillons sur le choix du matériel et assurons une pose conforme aux normes.",
    benefit: "Conseil personnalisé, pose dans les règles de l'art, finitions soignées.",
    icon: "Bath",
    seoTitle: "Installation Sanitaire à Meaux (77) | Pereira Plomberie Chauffage",
    seoDescription: "Installation de sanitaires à Meaux : WC, douche, lavabo, baignoire. Artisan plombier local. Travail soigné et conforme. Devis gratuit au 06 73 87 88 61.",
  },
  {
    slug: "chauffage",
    title: "Chauffage",
    shortDesc: "Pose et remplacement de chaudières, radiateurs et chauffe-eaux.",
    description: "Nous assurons l'installation et le remplacement de vos équipements de chauffage : chaudières gaz ou fioul, chauffe-eaux électriques ou thermodynamiques, radiateurs. Nous intervenons également pour les pannes et les mises en conformité. Notre objectif : votre confort thermique toute l'année.",
    benefit: "Expertise chauffage, installation conforme, économies d'énergie.",
    icon: "Flame",
    seoTitle: "Chauffage à Meaux (77) - Installation & Remplacement | Pereira Plomberie",
    seoDescription: "Installation et remplacement de chaudières, radiateurs et chauffe-eaux à Meaux. Artisan chauffagiste local qualifié. Devis gratuit au 06 73 87 88 61.",
  },
  {
    slug: "recherche-de-fuites",
    title: "Recherche de fuites",
    shortDesc: "Détection de fuites classiques ou encastrées sans destruction inutile.",
    description: "Une surconsommation d'eau inexpliquée ? Un mur humide ? Nous utilisons des techniques de détection adaptées pour localiser les fuites, même encastrées, avec un minimum de dégâts. Une fois la fuite identifiée, nous effectuons la réparation nécessaire.",
    benefit: "Détection précise, intervention ciblée, réparation rapide.",
    icon: "Droplets",
    seoTitle: "Recherche de Fuites à Meaux (77) | Détection & Réparation | Pereira",
    seoDescription: "Recherche et détection de fuites d'eau à Meaux et alentours. Fuites encastrées ou apparentes. Intervention rapide et ciblée. Contactez-nous au 06 73 87 88 61.",
  },
  {
    slug: "renovation-salle-de-bain",
    title: "Rénovation salle de bain",
    shortDesc: "Transformation complète de votre salle de bain, du sol au plafond.",
    description: "Envie de moderniser votre salle de bain ? Nous prenons en charge la rénovation complète : dépose de l'existant, plomberie, pose de carrelage, installation des sanitaires et équipements. Nous travaillons avec vous pour créer un espace fonctionnel et agréable, adapté à votre budget.",
    benefit: "Projet clé en main, suivi personnalisé, résultat soigné.",
    icon: "Paintbrush",
    seoTitle: "Rénovation Salle de Bain à Meaux (77) | Pereira Plomberie Chauffage",
    seoDescription: "Rénovation complète de salle de bain à Meaux. Plomberie, carrelage, sanitaires. Artisan local de confiance. Devis gratuit au 06 73 87 88 61.",
  },
  {
    slug: "urgence-plomberie",
    title: "Urgence plomberie",
    shortDesc: "Intervention d'urgence 7j/7 pour les situations critiques.",
    description: "Fuite importante, dégât des eaux, canalisation éclatée ? Ne restez pas sans solution. Nous intervenons en urgence à Meaux et dans un rayon de 25 km pour sécuriser la situation et effectuer les réparations nécessaires. Contactez-nous immédiatement.",
    benefit: "Disponibilité 7j/7, intervention rapide, sécurisation immédiate.",
    icon: "Siren",
    seoTitle: "Urgence Plomberie Meaux (77) - 7j/7 | Pereira Plomberie Chauffage",
    seoDescription: "Urgence plomberie à Meaux 7j/7. Fuite, dégât des eaux, canalisation. Intervention rapide. Appelez le 06 73 87 88 61 pour une prise en charge immédiate.",
  },
  {
    slug: "entretien-chaudiere",
    title: "Entretien chaudière & chauffe-eau",
    shortDesc: "Entretien annuel, détartrage et maintenance de vos équipements.",
    description: "L'entretien régulier de votre chaudière est obligatoire et essentiel pour votre sécurité et vos économies d'énergie. Nous assurons l'entretien annuel de chaudières gaz et fioul, ainsi que le détartrage de ballons d'eau chaude. Un équipement bien entretenu dure plus longtemps et consomme moins.",
    benefit: "Sécurité garantie, économies d'énergie, durée de vie prolongée.",
    icon: "Settings",
    seoTitle: "Entretien Chaudière à Meaux (77) | Pereira Plomberie Chauffage",
    seoDescription: "Entretien annuel de chaudière et chauffe-eau à Meaux. Détartrage, maintenance, mise en conformité. Artisan qualifié. Devis gratuit au 06 73 87 88 61.",
  },
];

export const zones = [
  { name: "Meaux", zip: "77100", primary: true },
  { name: "Esbly", zip: "77450" },
  { name: "Trilport", zip: "77470" },
  { name: "Lizy-sur-Ourcq", zip: "77440" },
  { name: "Saint-Soupplets", zip: "77165" },
  { name: "Crégy-les-Meaux", zip: "77124" },
  { name: "Quincy-Voisins", zip: "77860" },
  { name: "Mareuil-les-Meaux", zip: "" },
  { name: "Chauconin-Neufmontiers", zip: "77124" },
  { name: "Armentières-en-Brie", zip: "77440" },
  { name: "Congis-sur-Thérouanne", zip: "77440" },
];

export const testimonials = [
  { text: "Intervention rapide et efficace, je recommande à 100 %.", author: "Laurent D.", rating: 5 },
  { text: "Professionnel, ponctuel et travail propre. Merci encore !", author: "Nathalie B.", rating: 5 },
  { text: "Plombier très sérieux et à l'écoute. Le devis était clair et respecté.", author: "Yassine M.", rating: 5 },
];

export const faqItems = [
  { question: "Intervenez-vous en urgence à Meaux ?", answer: "Oui, nous intervenons en urgence 7j/7 à Meaux et dans un rayon de 25 km. Contactez-nous directement par téléphone au 06 73 87 88 61 pour une prise en charge rapide." },
  { question: "Faites-vous des devis gratuits ?", answer: "Oui, tous nos devis sont gratuits et sans engagement. Nous nous déplaçons pour évaluer vos besoins et vous proposer une solution adaptée à votre budget." },
  { question: "Réparez-vous les fuites encastrées ?", answer: "Oui, nous disposons de techniques de détection adaptées pour localiser les fuites, même encastrées dans les murs ou les sols, avec un minimum de dégâts." },
  { question: "Remplacez-vous les chauffe-eaux ?", answer: "Oui, nous assurons le remplacement de tous types de chauffe-eaux : électriques, gaz, thermodynamiques. Nous vous conseillons sur le modèle le plus adapté à vos besoins." },
  { question: "Dans quelles communes intervenez-vous ?", answer: "Nous intervenons à Meaux et dans un rayon d'environ 25 km, notamment à Esbly, Trilport, Lizy-sur-Ourcq, Saint-Soupplets, Crégy-les-Meaux, Quincy-Voisins et de nombreuses autres communes." },
  { question: "Quel est le délai d'intervention ?", answer: "En situation d'urgence, nous faisons notre maximum pour intervenir dans les plus brefs délais, souvent dans la journée. Pour les travaux programmés, nous convenons ensemble d'un rendez-vous à votre convenance." },
  { question: "Réalisez-vous des rénovations de salle de bain ?", answer: "Oui, nous prenons en charge la rénovation complète de votre salle de bain : plomberie, sanitaires, carrelage. Nous vous accompagnons du projet à la réalisation." },
  { question: "Travaillez-vous avec des particuliers et des professionnels ?", answer: "Oui, nous intervenons aussi bien chez les particuliers que pour les professionnels, les copropriétés et les gestionnaires immobiliers." },
];

export const reassurance = [
  { title: "Devis gratuit", desc: "Sans engagement, transparent", icon: "FileText" },
  { title: "Réponse rapide", desc: "Prise en charge sous 24h", icon: "Clock" },
  { title: "Intervention locale", desc: "Meaux et 25 km autour", icon: "MapPin" },
  { title: "Artisan de proximité", desc: "Entreprise familiale", icon: "Shield" },
];

export const requestTypes = [
  "Dépannage plomberie",
  "Installation sanitaire",
  "Chauffage",
  "Recherche de fuites",
  "Rénovation salle de bain",
  "Urgence plomberie",
  "Entretien chaudière",
  "Autre demande",
];
